import React, { Component } from 'react';
import './services.scss';
import timer from '../../assets/img/stopwatch.svg';
import boat from '../../assets/img/boat.svg';
import parking from '../../assets/img/pallet.svg';
import transport from '../../assets/img/delivery-truck.svg';
import storage from '../../assets/img/warehouse.svg';
import wash from '../../assets/img/car-wash.svg';

export default class Services extends Component {
    render() {
        return (
            <div className='services'>
                <div className='row mt-3'>
                    <div className='row w-100'>
                        <div className='col-md-12 text-center'>
                            <span className='services-main'>Services</span>
                            <hr className='w-75 bg-danger' />
                        </div>
                    </div>
                    <div className='row w-100'>
                        <div className='col-md-12 pl-5 pr-5 text-center'>
                            <span className='services-main-words w-75'>
                                Decade trucking has an active account with Transnet. We are currently involved in
                                railing containers to destinations such as Port Elizabeth, Cape Town, East London,
                                Bloemfontein, Durban and etc. we also pick up imports from Transnet city deep and
                                deliver in and around Gauteng,Limpopo,Tohoyandou, Mpumalanga and north west. we pick and
                                pack exports, Containerized cargo, break-bulk and Dangerous goods. We can also collect
                                DROs at no extra charge.
                            </span>
                            <hr className='w-25 bg-danger' />
                        </div>
                    </div>
                </div>
                <div className='row w-100'>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={boat} className='services-icon__Export' />
                            </div>
                            <div className='text-center'>
                                <span>Export And Import</span>
                            </div>
                        </span>
                    </div>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={timer} className='services-icon__TruckStop' />
                            </div>
                            <div className='text-center'>
                                <span>Truck Stop</span>
                            </div>
                        </span>
                    </div>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={parking} className='services-icon__TruckParking' />
                            </div>
                            <div className='text-center'>
                                <span>Truck Parking</span>
                            </div>
                        </span>
                    </div>
                </div>
                <div className='row w-100'>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={transport} className='services-icon__Transport' />
                            </div>
                            <div className='text-center'>
                                <span>Transport And Logistics</span>
                            </div>
                        </span>
                    </div>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={storage} className='services-icon__Storage' />
                            </div>
                            <div className='text-center'>
                                <span>Storage</span>
                            </div>
                        </span>
                    </div>
                    <div className='col-md-4'>
                        <span className='services-icon w-100 hvr-float-shadow'>
                            <div className='text-center'>
                                <img src={wash} className='services-icon__Wash' />
                            </div>
                            <div className='text-center'>
                                <span className='p-3'>Truck Wash</span>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
